<template>
  <div class="trend-card">    
    <div class="trend-card__image">
      <img
        :src="trend.imageUrl"
        alt=""
      >
    </div>
    <a
      :href="trend.url"
      data-gtmcat="trend engagement"
      data-gtmaction="click"
      :data-gtmlabel="trend.title | striphtml"
    >
      {{ trend.title }}
      <div v-if="debug">
        <span 
          v-for="(tagId, index) in trend.tags"
          :key="index"
        >
          {{ "[" + tagName(tagId) + "] " }}
        </span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "Trend",
  props: {
    trend: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => {
    return {
      debug: false,
    }
  },
  computed: {
    segments() {
      let segments = []
      segments = this.trend.tags ? this.trend.tags["Segment"] : null
      return segments ? segments.join(', ') : ''
    },
    formattedDate() {
      let date = new Date(this.trend.publishDate)
      return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
    }
  },
  created() {
    //console.log(this.trend)
  },
  methods: {
    tagName(id) {
      return this.$store.state.filters.find(function(filt) {
        return filt.id == id;
      }).name;
    }
  }
}
</script>

